import React from "react";

const UserRolesCell: React.FC<{
  roles: string[];
}> = React.memo(({ roles }) => {
  return (
    <p
      className={`pulse-typography-body-1 ${
        roles && roles.length > 0
          ? "pulse-color--background-100"
          : "pulse-color--background-300"
      }`}
    >
      {roles && roles.length > 0
        ? roles.includes("admin")
          ? "Admin"
          : "Viewer"
        : "No Roles"}
    </p>
  );
});

export default UserRolesCell;
